import { render, staticRenderFns } from "./requirements.vue?vue&type=template&id=5cf89c2d&"
import script from "./requirements.vue?vue&type=script&lang=js&"
export * from "./requirements.vue?vue&type=script&lang=js&"
import style0 from "./requirements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports